import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable, {
  pickConfigs,
} from "app/components/AppComponents/ConfigurableTable";
import paymentColumns from "./paymentColumns";

type Props = {
  name: string;
  externalReference: string;
  createdAtFrom: string;
  createdAtTo: string;
  onLoaded: (data: any) => void;
  history: any;
};

const query = gql`
  query UserPayments(
    $externalReference: ID!
    $offset: Int
    $limit: Int
    $createdAtFrom: String
    $createdAtTo: String
  ) {
    user(external_reference: $externalReference) {
      email
      payments(
        offset: $offset
        limit: $limit
        created_at_from: $createdAtFrom
        created_at_to: $createdAtTo
      ) {
        created_at
        payment_token
        reference
        payable_amount
        merchant_amount
        user_fee_amount
        status
        payment_strategy
        snapmin_url
        secure3d_requested
        device {
          phone_number
          snapmin_url
          external_reference
        }
        merchant {
          name
          id
          snapmin_url
        }
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({
    externalReference,
    createdAtFrom,
    createdAtTo,
    pagination: { offset, limit },
  }) => ({
    fetchPolicy: "network-only",
    variables: {
      externalReference,
      createdAtFrom,
      createdAtTo,
      offset,
      limit,
    },
  }),
});

export default withPagination(
  withData((props) => (
    <BOGraphQLLoader data={props.data} onLoaded={props.onLoaded}>
      <ConfigurableTable
        columnConfigs={pickConfigs(paymentColumns, [
          "Date",
          "Payment token",
          "Reference",
          "Snapmin",
          "Payable amount",
          "Amount (Merchant)",
          "Service fee",
          "Payment strategy",
          "Merchant",
          "Device",
          "Secure 3D",
        ])}
        defaultColumns={[
          "Date",
          "Payable amount",
          "Amount (Merchant)",
          "Service fee",
          "Payment strategy",
          "Merchant",
          "Device",
          "Secure 3D",
        ]}
        rows={(props.data.user && props.data.user.payments) || []}
        rowToLink={(row) => `/snapscan/ops/payments/${row.reference}/summary`}
        pagination={props.pagination}
        name={props.name}
        history={props.history}
      />
    </BOGraphQLLoader>
  ))
);
